import PropTypes from 'prop-types';
import ArrowRightIcon from '@mui/icons-material/ArrowForward';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import SvgIcon from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';

export const OverviewMultis = (props) => {
  const {
    values = [],
    title = 'Done Tasks',
    imgIcon = '/assets/iconly/iconly-glass-tick.svg',
    button,
    onClicked,
  } = props;

  return (
    <Card sx={{ borderRadius: 2, boxShadow: 2 }}>
      <Stack
        alignItems="center"
        direction={{
          xs: 'column',
          sm: 'row',
        }}
        spacing={1}
        sx={{
          px: 2,
          py: 1,
        }}
      >
        {/* Icon Wrapper */}
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <img src={imgIcon} width={48} alt={`${title} Icon`} />
        </Box>

        {/* Text Section */}
        <Box sx={{ flexGrow: 1 }}>
          <Typography color="text.secondary" variant="body2" sx={{ mb: 1 }}>
            {title}
          </Typography>
          {values.map((element, index) => (
            <Typography 
              key={index} 
              color="text.primary" 
              sx={{ fontSize: `${(20 - index * 2) / 16}rem`, mb: 0.5 }} // Adjust font size dynamically
            >
              {element}
            </Typography>
          ))}
        </Box>
      </Stack>
      <Divider />

      {/* Button */}
      {button && (
        <CardActions>
          <Button
            color="inherit"
            endIcon={
              <SvgIcon>
                <ArrowRightIcon />
              </SvgIcon>
            }
            size="small"
            onClick={onClicked}
          >
            {button}
          </Button>
        </CardActions>
      )}
    </Card>
  );
};

OverviewMultis.propTypes = {
  values: PropTypes.oneOfType([PropTypes.array]).isRequired, // The main string value to display
  title: PropTypes.string, // The title of the card
  imgIcon: PropTypes.string, // The URL or path to the image icon
  button: PropTypes.string, // The text of the button
  onClicked: PropTypes.func, // The click handler function for the button
};
